var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9167 0.25H5.08333C3.80145 0.25 2.57208 0.759225 1.66565 1.66565C0.759225 2.57208 0.25 3.80145 0.25 5.08333V38.9167C0.25 40.1985 0.759225 41.4279 1.66565 42.3343C2.57208 43.2408 3.80145 43.75 5.08333 43.75H38.9167C40.1985 43.75 41.4279 43.2408 42.3343 42.3343C43.2408 41.4279 43.75 40.1985 43.75 38.9167V5.08333C43.75 3.80145 43.2408 2.57208 42.3343 1.66565C41.4279 0.759225 40.1985 0.25 38.9167 0.25ZM14.75 34.0833H8.65227V17.1667H14.75V34.0833ZM11.5948 14.0656C9.73107 14.0656 8.48793 12.8244 8.48793 11.1656C8.48793 9.5068 9.73107 8.2656 11.8017 8.2656C13.6654 8.2656 14.9085 9.50873 14.9085 11.1656C14.9085 12.8225 13.6654 14.0656 11.5948 14.0656ZM36.5 34.0833H30.5995V24.8381C30.5995 22.2803 29.0257 21.6907 28.4361 21.6907C27.8464 21.6907 25.8783 22.0851 25.8783 24.8381V34.0833H19.7805V17.1667H25.8783V19.5273C26.6632 18.1488 28.2369 17.1667 31.1872 17.1667C34.1375 17.1667 36.4981 19.5273 36.4981 24.8381V34.0833H36.5Z",
    fill: "#673DE6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.b61b2ad61b01f6ae0fd7a6aab49d7faa.svg";
export { ForwardRef as ReactComponent };